import React from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
// eslint-disable-next-line import/no-cycle
import {
    ConnectedNewPaymentMethod,
    ConnectedUpdateShouldRevertPaymentType,
    ConnectedUpdateShouldDisplayApplePay,
} from "../Pages/PaymentPage";

const PaymentContentControl = ({
    displayDontOweAnythingMessage,
    formik,
    sectionHeading,
    paymentDetailsAdditionalText = "",
    displayPayment,
    controlId,
    isCms,
}) => {
    // useLocation() is to pass location info because in CMS using withRouter()
    // will throw errors as this component is not wrapped a <Router/> component
    // -------------------------------------------------------------------------
    // TODO: Fix this conditional use of hooks, possibly by adding
    // a nullish coalescing
    // const location = useLocation() ?? undefined;
    // -------------------------------------------------------------------------
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = isCms ? { pathname: "" } : useLocation();

    // Running the update component in the payment control ensures that the
    // Apple Pay button is displayed in CMS
    return (
        <>
            {/* Outside displayPayment as payment type needs to be updated if total <= 0 */}
            <ConnectedUpdateShouldRevertPaymentType location={location} />
            {displayPayment && (
                <>
                    <ConnectedUpdateShouldDisplayApplePay />
                    <div className="grid">
                        {/* Keep spacing above and below RegistrationContent consistent */}
                        <div className="col col--12 -padding-top--30">
                            <h3 id="aria-payment-page-header">
                                <Icon
                                    className="-margin-right--5"
                                    glyph="lock-alt-solid"
                                    type="FontAwesome"
                                />{" "}
                                {sectionHeading}
                            </h3>
                            <p>{paymentDetailsAdditionalText}</p>
                        </div>
                        <ConnectedNewPaymentMethod
                            controlId={controlId}
                            formik={formik}
                        />
                    </div>
                </>
            )}
            {displayDontOweAnythingMessage && (
                <div className="grid">
                    <div className="col col--12 -padding-top--60 -padding-bottom--10">
                        <p className="-text--center">
                            Looks like you don&apos;t owe anything! Just
                            complete your registration below.
                        </p>
                    </div>
                </div>
            )}
        </>
    );
};

PaymentContentControl.propTypes = {
    displayDontOweAnythingMessage: PropTypes.bool.isRequired,
    formik: PropTypes.shape({}).isRequired,
    sectionHeading: PropTypes.string.isRequired,
    paymentDetailsAdditionalText: PropTypes.string,
    displayPayment: PropTypes.bool.isRequired,
    controlId: PropTypes.number.isRequired,
    isCms: PropTypes.bool.isRequired,
};

export default PaymentContentControl;
